<template>
  <div class="confirmorder-page">
    <header>确认注册方案</header>
    <div class="info-title">
      <i class="selftmreg_shuxian"></i>
      <h4>商标信息</h4>
    </div>
    <!-- 商标信息 -->
    <div class="brand-info">
      <p>
        <strong>商标类型：</strong>
        <span>文字</span>
      </p>
      <p>
        <strong>商标名称：</strong>
        <span>萌颜</span>
      </p>
      <p>
        <strong>商标图样：</strong>
        <img :src="brandIcon" alt />
      </p>
      <p>
        <strong>商标类别：</strong>
        <span class="detail-type">
          <i>03 类 日化用品</i>
          <br />
          <b>03007 杏仁肥皂</b>
          <b>03009 洗涤上光分</b>
          <b>03010 洗衣用淀粉</b>
          <b>03010 洗衣用浆粉</b>
          <b>03012 肥皂</b>
          <b>03013 纺织品上光皂</b>
          <b>03014 洗衣用上蓝剂</b>
          <b>03017 剃须皂</b>
          <b>03026 漂白盐</b>
          <b>03027 漂白碱</b>
        </span>
      </p>
    </div>

    <div class="info-title">
      <i class="selftmreg_shuxian"></i>
      <h4>申请人及联系人信息</h4>
    </div>
    <!-- 申请人及联系人信息 -->
    <div class="user-info">
      <ul>
        <li>
          <strong>申请人类型：</strong>
          <span>企业</span>
        </li>
        <li>
          <strong>公司名称：</strong>
          <span>北京联大共享科技有限公司</span>
        </li>
        <li>
          <strong>邮政编码：</strong>
          <span>102400</span>
        </li>
        <li>
          <strong>公司地址：</strong>
          <span>北京市房山区良乡凯旋大街建设路18号-D740</span>
        </li>
        <li>
          <strong>联系人：</strong>
          <span>Mary</span>
        </li>
        <li>
          <strong>联系电话：</strong>
          <span>13412341234</span>
        </li>
        <li>
          <strong>电子邮箱：</strong>
          <span>123@qq.com</span>
        </li>
        <li>
          <strong>信用编码：</strong>
          <span>91110111MA002EX819</span>
        </li>
      </ul>
    </div>

    <!-- 材料信息 -->
    <div>
      <div class="info-title">
        <i class="selftmreg_shuxian"></i>
        <h4>交官材料</h4>
      </div>
      <div class="show-imgs">
        <ul>
          <li>
            <img src />
          </li>
        </ul>
      </div>
    </div>

    <div class="agree-btns">
      <el-button>同意该注册方案</el-button>
      <el-button type="primary">不同意该注册方案</el-button>
    </div>
    <p>注：如果同意该注册方案后，我们即可递交商标局，如果不同意，请填写理由。</p>
    <div class="bottom-spacepadding"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      brandIcon: "" // 商标展示
    };
  },
  methods: {},
  created() {}
};
</script>

<style lang="scss" scoped>
.confirmorder-page {
  width: 1200px;
  margin: 0 auto;
  border: 1px solid #dcdfe6;
  padding: 0px 20px;
  margin-bottom: 20px;
  header {
    font-size: 20px;
    font-family: PingFangSC;
    font-weight: 800;
    padding: 20px 0px;
    border-bottom: #d6daeb 1px solid;
    margin-bottom: 20px;
  }
  .agree-btns {
    padding: 20px 0px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
  }
  .bottom-spacepadding {
    height: 20px;
  }
}
.info-title {
  .selftmreg_shuxian {
    width: 3px;
    height: 15px;
    background-color: #0989c5;
    display: inherit;
    float: left;
    margin-top: 4px;
    margin-right: 10px;
  }
  h4 {
    font-size: 16px;
    font-family: PingFangSC;
    font-weight: 400;
    color: rgba(83, 83, 83, 1);
    margin-bottom: 15px;
    strong {
      margin-left: 35px;
      font-size: 14px;
      font-family: PingFangSC;
      font-weight: 400;
      color: rgba(99, 101, 105, 1);
    }
  }
}
// 编辑图文
.edit {
  color: #409efe;
}

// 商标信息
.brand-info {
  p {
    margin-bottom: 23px;
    strong {
      width: 120px;
      display: inline-block;
      text-align: right;
      color: rgb(99, 101, 105);
    }
    span {
      font-size: 14px;
      font-weight: 400;
      color: #333;
    }
    span.detail-type {
      display: inline-block;
      width: 900px;
      vertical-align: top;
      i {
        font-size: 14px;
        font-weight: 600;
        display: inline-block;
        padding-bottom: 10px;
      }
      b {
        font-size: 14px;
        font-weight: 400;
        margin-right: 20px;
        text-align: left;
        color: #333;
      }
    }
    img {
      display: inline-block;
      width: 140px;
      height: 140px;
      border: 2px dashed rgb(233, 233, 233);
      vertical-align: top;
    }
  }
}

// 申请人及联系人信息
.user-info {
  ul {
    li {
      display: inline-block;
      width: 50%;
      padding-bottom: 23px;
      strong {
        width: 120px;
        display: inline-block;
        text-align: right;
        color: rgb(99, 101, 105);
      }
      span {
        font-size: 14px;
        font-weight: 400;
        color: #333;
      }
    }
  }
}

// 材料信息
.show-imgs {
  padding-left: 44px;
  ul {
    display: flex;
    li {
      display: inline-block;
      margin-left: 15px;
      width: 100px;
      height: 140px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      img {
        display: block;
        height: 118px;
        width: 98px;
        border: 2px dashed rgb(233, 233, 233);
      }
      span {
        color: #636569;
        font-size: 14px;
        line-height: 20px;
      }
    }
  }
}
</style>
